import React from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup
} from "reactstrap";

export const CardLogin = ({history, onChange, errorMessage, doLogin}) => (
    <Card className="card-login">
        <CardHeader>
            <CardHeader className="card-login-header">
                <img src={require("assets/img/logo-murilo.png")}></img>
                <h3 className="header text-center">Seja bem-vindo(a)!</h3>
            </CardHeader>
        </CardHeader>
        <CardBody>
            <label className="label-input">Senha</label>
            <InputGroup>
                <Input 
                    placeholder="E-mail" 
                    type="text" 
                    onChange={(e) => onChange("email", e.target.value)} />
            </InputGroup>
            <label className="label-input">Senha</label>
            <InputGroup>
                <Input 
                    placeholder="Senha"
                    type="password"
                    autoComplete="off"
                    onChange={(e) => onChange("password", e.target.value)}
                />
            </InputGroup>
        </CardBody>
        <CardFooter>
            <Button
                className=" btn-login-access"
                color="warning"
                onClick={doLogin}
            >
                Acessar
                    </Button>
            {errorMessage && <span className="text-error text-center">{errorMessage}</span>}
            {/* <a
                className="login-recovery-label"
                onClick={() => history.push("/auth/recovery")}
            >
                Esqueci minha senha
            </a> */}
        </CardFooter>
    </Card>
);


export const CardRecovery = ({onChange, errorMessage, submit}) => (
    <Card className="card-login">
        <CardHeader>
            <CardHeader className="card-login-header">
                <img src={require("assets/img/logo-promos.png")}></img>
                <h3 className="header-recovery text-center">Digite seu email para recuperar a senha</h3>
            </CardHeader>
        </CardHeader>
        <CardBody>
            <InputGroup>
                <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                        <i className="nc-icon nc-email-85" />
                    </InputGroupText>
                </InputGroupAddon>
                <Input placeholder="E-mail" type="text" onChange={(e) => onChange("email", e.target.value)} />
            </InputGroup>
        </CardBody>
        <CardFooter>
            <Button
                className="btn-round mb-3 btn-login-access"
                color="warning"
                onClick={submit}
            >
                Recuperar
                    </Button>
            {errorMessage && <span className="text-error text-center">{errorMessage}</span>}
        </CardFooter>
    </Card>
);